import { NgModule } from '@angular/core';
import { SendungsDetailLibComponent } from './sendungs-detail-lib.component';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';



@NgModule({
  declarations: [SendungsDetailLibComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule
  ],
  exports: [SendungsDetailLibComponent]
})
export class SendungsDetailLibModule { }
